import { useDispatch } from 'react-redux';
import { configureStore, StateFromReducersMapObject } from '@reduxjs/toolkit';
import { merchantInfoReducer } from '@store/merchant-info/reducer';
import { qrCodeReducer } from '@store/qr-code/reducer';
import { paymentStatusReducer } from '@store/payment-status/reduser';
import { appReducer } from './app';

export const reducers = {
    app: appReducer,
    merchantInfo: merchantInfoReducer,
    qrCode: qrCodeReducer,
    paymentStatus: paymentStatusReducer,
};

export const store = configureStore({
    reducer: reducers,
});

export type ApplicationState = StateFromReducersMapObject<typeof reducers>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
